import * as v from "valibot";

/**
 * Search params come from the URL, so they can be hand-edited or written by
 * other systems. A value of the wrong type must degrade to "absent" instead of
 * making `validateSearch` throw, which would put the router on its raw error
 * screen.
 */
const lenient = schema => v.fallback(v.optional(schema), undefined);
export const signInSearchSchema = v.object({
  meddelande: lenient(v.string()),
  bekraftelsemeddelande: lenient(v.string())
});
export const signUpSearchSchema = v.object({
  meddelande: lenient(v.string()),
  bekraftelsemeddelande: lenient(v.string())
});

// Better Auth redirects an expired or used reset link here with `error` and no
// `token`, so neither can be required.
export const resetPasswordSearchSchema = v.object({
  token: lenient(v.string()),
  error: lenient(v.string()),
  meddelande: lenient(v.string())
});
export const requestResetPasswordSearchSchema = v.object({
  error: lenient(v.string()),
  meddelande: lenient(v.string())
});
export const emailVerifiedSearchSchema = v.object({
  next: lenient(v.string()),
  error: lenient(v.string())
});
export const kartaSearchSchema = v.object({
  plats: lenient(v.number()),
  bidra: lenient(v.boolean())
});
export const bidraSearchSchema = v.object({
  plats: lenient(v.number()),
  platsNamn: lenient(v.string())
});
export const searchPageSearchSchema = v.object({
  q: lenient(v.string())
});